import { render, staticRenderFns } from "./DetailLaporanPenelitiKeamanan.vue?vue&type=template&id=33c37581&"
import script from "./DetailLaporanPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports